import React, { useEffect } from 'react';
import { useAnalytics } from '../../utils/analytics-provider/analytics-provider';
import { useSearchState } from './context';
import { Header, Results, NoResults, Loading } from './components';

const Search = () => {
  const {
    resultsTotal,
    resultsLoading,
    page: currentPage,
    pagesTotal,
    query,
    results,
    source
  } = useSearchState();
  const { trackEvent } = useAnalytics();
  useEffect(() => {
    trackEvent('page_hit', { page_hit: 'search' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const trackingEvent = () =>
      trackEvent('search_terms_and_results', {
        data: { resultsTotal, currentPage, pagesTotal, query, results, source }
      });
    const timer = setTimeout(trackingEvent, 250);
    return () => clearTimeout(timer);
  }, [resultsTotal, currentPage, pagesTotal, query, results]);

  return (
    <>
      <Header />
      {resultsLoading && <Loading />}
      {resultsTotal && !resultsLoading ? <Results /> : <NoResults />}
    </>
  );
};

export default Search;
